import { render } from "./LinkedBOMs.vue?vue&type=template&id=aa2cef16&scoped=true"
import script from "./LinkedBOMs.vue?vue&type=script&lang=js"
export * from "./LinkedBOMs.vue?vue&type=script&lang=js"

import "./LinkedBOMs.vue?vue&type=style&index=0&id=aa2cef16&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa2cef16"]])

export default __exports__